import React, { useState } from 'react';
import * as math from 'mathjs';

const MeanVarianceOptimization = ({ selectedAssets, gamma, covarianceMatrix, returnsArray }) => {
    // Validation
    console.log("The asset is xxx", selectedAssets);
    console.log("The gamma is xxx", gamma);
    console.log("The covariance matrix is xxx", covarianceMatrix);
    console.log("The returns arrays is xxx", returnsArray);
    if (!selectedAssets || selectedAssets.length < 2) {
        console.error("You need to select at least two assets.");
        return []; // Return null to indicate failure or incomplete calculation
    }
    // Validation => I would like you to calculate the sam Vacumn
    const numAssets = returnsArray.length;
    const sigmaInverse = math.inv(covarianceMatrix);
    // Assuming returnsArray is a 1D array, convert it into a column vector properly
    const muColumnVector = math.matrix(returnsArray).resize([numAssets, 1]);
    const onesColumnMatrix = math.ones(numAssets, 1);
    const sigmaInverseTimesOnes = math.multiply(sigmaInverse, onesColumnMatrix);
    // Correct handling of dimensions for multiplication

    const onesTranspose = math.transpose(onesColumnMatrix);

    const variance = math.multiply(onesTranspose, sigmaInverseTimesOnes);
    const varianceScalar = typeof variance === 'number' ? variance : variance.valueOf()[0][0];
    const numerator2_1 = math.multiply(varianceScalar, math.multiply(sigmaInverse, muColumnVector));

    const numerator2_2_1 = math.multiply(onesTranspose, math.multiply(sigmaInverse, muColumnVector));

    const numerator2_2_2 = math.multiply(sigmaInverse, onesColumnMatrix);
    const numerator2_2 = math.multiply(numerator2_2_1.valueOf()[0][0], numerator2_2_2);
    const gammaScalar = typeof gamma === 'number' ? gamma : gamma.valueOf()[0][0];
    const numerator2 = math.multiply(gammaScalar, math.subtract(numerator2_1, numerator2_2));
    const part2 = math.divide(numerator2, variance);
    const part1 = math.divide(sigmaInverseTimesOnes, variance);
    const weights = math.add(part1, part2);
    return math.transpose(weights).toArray(); // Convert math.js Matrix to Array for easier handling

}
export default MeanVarianceOptimization;
